// web/src/App.tsx
import Loading from '@components/Loading';
import StyledApp from '@components/StyledApp';
import { persistor, setupStore } from '@store/store';
import React, { useEffect, useMemo } from 'react';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { useAppSelector } from '@store/hooks';
import 'swiper/css';
import 'swiper/css/bundle';

// Dark Mode Styles
import './themes/styles/dark.css';
import './themes/styles/fonts.css';
import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';
// Globals Styles
import './themes/styles/globals.css';
// Remix Icon
import './themes/styles/remixicon.css';
// Css Import
import 'react-tabs/style/react-tabs.css';

const App: React.FC = () => {
  return (
    <Router>
      <StoreProvider />
    </Router>
  );
};
const TelemetryUserContextSync: React.FC = () => {
  const user = useAppSelector((state) => state.auth.user);

  useEffect(() => {
    if (user) {
      Sentry.setUser({
        id: user.userId,
        username: user.userName,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);

  return null;
};

const StoreProvider: React.FC = () => {
  const navigate = useNavigate();
  //eslint-disable-next-line react-hooks/exhaustive-deps
  const store = useMemo(() => setupStore(navigate), []);
  //eslint-disable-next-line react-hooks/exhaustive-deps
  const persistedStore = useMemo(() => persistor(store), []);

  return (
    <Provider store={store}>
      <PersistGate loading={<Loading size={50} />} persistor={persistedStore}>
        <TelemetryUserContextSync />
        <StyledApp />
      </PersistGate>
    </Provider>
  );
};

export default App;
